<template>
  <section class="shop">
    <Header class="header" />
    <div class="router">
      <router-view />
    </div>
  </section>
</template>

<script>
import Header from '@/components/organisms/Header'

export default {
  components: {
    Header
  }
}
</script>

<style lang="scss" scoped>
.shop {
  height: 100%;

  display: grid;
  grid-template-rows: 0px minmax(15%, 0.1fr) auto;
  grid-template-areas: "." "header" "content";
  grid-gap: 10px;
}

.header {
  grid-area: header;
}

.router {
  grid-area: content;
  width: 100vw;

  & > *:first-child {
    height: 100%;
  }
}
</style>
